class LanguageTranslations {
  static codes(showMore) {
    if (!showMore) {
      return Object.keys(this.translations)
    }
    return ['pl', 'ro', 'ur', 'pt', 'es', 'ar', 'pa', 'it', 'fr', 'en']
  }

  static translations = {
    en: {
      code: 'en',
      name: 'English',
      flag: 'https://flagcdn.com/w40/gb.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    ab: {
      code: 'ab',
      name: 'Abkhazian',
      flag: 'https://flagcdn.com/w40/ab.png',
      direction: 'ltr',
      next: 'Анаҩсантәи',
      previous: 'уаанӡатәи',
      submit: 'адкылара',
      errSelect: 'Ҳаҳәоит, азҵаара аҭак ҟашәҵа',
      errAtMost: 'Ҳаҳәоит, иалышәх еиҳарак {**} аопциақәа',
      errAtleast: 'Ҳаҳәоит, иалышәх иаҵанакуа {**} аопциақәа',
      errExactly: 'Иалышәх ииашаҵәҟьаны {**} аопциақәа',
      errRequired: 'Ашықәсра аихьӡара',
      alreadySubmitted: 'Уара аҭак ҟауҵеит',
      endMessage: 'Ишәыдысныҳәалоит! Аҭҵаара хыркәшоуп 🎉',
      closedMessage: 'Аҭҵаара аркуп',
    },
    ace: {
      code: 'ace',
      name: 'Acehnese',
      flag: 'https://flagcdn.com/w40/id.png',
      direction: 'ltr',
      next: 'Lajeh',
      previous: 'Sebelom',
      submit: 'Kirim',
      errSelect: 'Silahkan jawab pertanyaan',
      errAtMost: 'Pilih paling banyak {**} opsi',
      errAtleast: 'Pilih setidaknya {**} opsi',
      errExactly: 'Pilih tepat {**} opsi',
      errRequired: 'Bidang ini wajib diisi',
      alreadySubmitted: 'Anda sudah mengirim survei ini',
      endMessage: 'Selamat! Anda telah menyelesaikan survei 🎉',
      closedMessage: 'Survei ini sudah ditutup',
    },
    ach: {
      code: 'ach',
      name: 'Acholi----',
      flag: 'https://flagcdn.com/w40/ug.png',
      direction: 'ltr',
      next: 'Kwo',
      previous: 'Kwo me',
      submit: 'Kwo me',
      errSelect: 'Tye kwo me',
      errAtMost: 'Tye kwo me {**} kwo me',
      errAtleast: 'Tye kwo me {**} kwo me',
      errExactly: 'Tye kwo me {**} kwo me',
      errRequired: 'Kwo me kwo me',
      alreadySubmitted: 'Itye kwo me kwo me',
      endMessage: 'Itye kwo me kwo me! Itye kwo me kwo me 🎉',
      closedMessage: 'Kwo me kwo me',
    },
    af: {
      code: 'af',
      name: 'Afrikaans',
      flag: 'https://flagcdn.com/w40/za.png',
      direction: 'ltr',
      next: 'Volgende',
      previous: 'Vorige',
      submit: 'Indien',
      errSelect: 'Beantwoord asseblief die vraag',
      errAtMost: 'Kies hoogstens {**} opsies',
      errAtleast: 'Kies ten minste {**} opsies',
      errExactly: 'Kies presies {**} opsies',
      errRequired: 'Hierdie veld is verpligtend',
      alreadySubmitted: 'U het hierdie opname reeds ingedien',
      endMessage: 'Baie geluk! U het die opname voltooi 🎉',
      closedMessage: 'Hierdie opname is gesluit',
    },
    sq: {
      code: 'sq',
      name: 'Albanian',
      flag: 'https://flagcdn.com/w40/al.png',
      direction: 'ltr',
      next: 'Tjetër',
      previous: 'I mëparshëm',
      submit: 'Dërgo',
      errSelect: 'Ju lutemi përgjigjuni pyetjes',
      errAtMost: 'Ju lutemi zgjidhni maksimumi {**} opsione',
      errAtleast: 'Ju lutemi zgjidhni të paktën {**} opsione',
      errExactly: 'Ju lutemi zgjidhni saktësisht {**} opsione',
      errRequired: 'Ky fushë është e detyrueshme',
      alreadySubmitted: 'Keni dërguar tashmë këtë anketë',
      endMessage: 'Urime! Keni përfunduar anketën 🎉',
      closedMessage: 'Kjo anketë është mbyllur',
    },
    alz: {
      code: 'alz',
      name: 'Alur',
      flag: '',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    am: {
      code: 'am',
      name: 'Amharic',
      flag: 'https://flagcdn.com/w40/et.png',
      direction: 'ltr',
      next: 'ቀጣይ',
      previous: 'የቀደመ',
      submit: 'አቅርብ',
      errSelect: 'እባክዎ ጥያቄውን ይመልሱ',
      errAtMost: 'እባክዎ ቢያንስ {**} አማራጮች ይምረጡ',
      errAtleast: 'እባክዎ ቢያንስ {**} አማራጮች ይምረጡ',
      errExactly: 'እባክዎ ትክክለኛውን {**} አማራጭ ይምረጡ',
      errRequired: 'ይህ መስክ ያስፈልጋል',
      alreadySubmitted: 'ይህን ዳግም አስገብተዋል',
      endMessage: 'እንኳን ደስ አለዎት! ዳሰሳውን ጨርሰዋል 🎉',
      closedMessage: 'ይህ ዳሰሳ ተዘግቷል',
    },
    ar: {
      code: 'ar',
      name: 'Arabic',
      flag: 'https://flagcdn.com/w40/sa.png',
      direction: 'rtl',
      next: 'التالي',
      previous: 'السابق',
      submit: 'إرسال',
      errSelect: 'يرجى الإجابة على السؤال',
      errAtMost: 'يرجى اختيار {**} خيارات على الأكثر',
      errAtleast: 'يرجى اختيار {**} خيارات على الأقل',
      errExactly: 'يرجى اختيار {**} خيارات بالضبط',
      errRequired: 'هذا الحقل مطلوب',
      alreadySubmitted: 'لقد قمت بالفعل بتقديم هذا الاستطلاع',
      endMessage: 'تهانينا! لقد أكملت الاستطلاع 🎉',
      closedMessage: 'هذا الاستطلاع مغلق',
    },
    hi: {
      code: 'hi',
      name: 'Hindi',
      flag: 'https://flagcdn.com/w40/in.png',
      direction: 'ltr',
      next: 'अगला',
      previous: 'पिछला',
      submit: 'सबमिट करें',
      errSelect: 'कृपया प्रश्न का उत्तर दें',
      errAtMost: 'कृपया अधिकतम {**} विकल्प चुनें',
      errAtleast: 'कृपया कम से कम {**} विकल्प चुनें',
      errExactly: 'कृपया ठीक {**} विकल्प चुनें',
      errRequired: 'यह फ़ील्ड आवश्यक है',
      alreadySubmitted: 'आपने पहले ही इस सर्वेक्षण को सबमिट कर दिया है',
      endMessage: 'बधाई हो! आपने सर्वेक्षण पूरा कर लिया 🎉',
      closedMessage: 'यह सर्वेक्षण बंद है',
    },
    hy: {
      code: 'hy',
      name: 'Armenian',
      flag: 'https://flagcdn.com/w40/am.png',
      direction: 'ltr',
      next: 'Հաջորդը',
      previous: 'Նախորդը',
      submit: 'Ուղարկել',
      errSelect: 'Խնդրում ենք պատասխանել հարցին',
      errAtMost: 'Խնդրում ենք ընտրել առավելագույնը {**} տարբերակ',
      errAtleast: 'Խնդրում ենք ընտրել առնվազն {**} տարբերակ',
      errExactly: 'Խնդրում ենք ընտրել ճիշտ {**} տարբերակ',
      errRequired: 'Այս դաշտը պարտադիր է',
      alreadySubmitted: 'Դուք արդեն ուղարկել եք այս հարցումը',
      endMessage: 'Շնորհավորում ենք! Դուք ավարտեցիք հարցումը 🎉',
      closedMessage: 'Այս հարցումը փակ է',
    },
    as: {
      code: 'as',
      name: 'Assamese',
      flag: 'https://flagcdn.com/w40/in.png',
      direction: 'ltr',
      next: 'পৰৱৰ্তী',
      previous: 'পূৰ্বৱৰ্তী',
      submit: 'জমা কৰক',
      errSelect: 'অনুগ্ৰহ কৰি প্ৰশ্নটোৰ উত্তৰ দিয়ক',
      errAtMost: 'সৰ্বাধিক {**} বিকল্প বাছনি কৰক',
      errAtleast: 'অন্তত {**} বিকল্প বাছনি কৰক',
      errExactly: '{**} বিকল্প ঠিক বাছনি কৰক',
      errRequired: 'এই ক্ষেত্ৰটো আৱশ্যক',
      alreadySubmitted: 'আপুনি এই সমীক্ষা ইতিমধ্যে জমা দিছে',
      endMessage: 'অভিনন্দন! আপুনি সমীক্ষা সম্পূৰ্ণ কৰিছে 🎉',
      closedMessage: 'এই সমীক্ষা বন্ধ',
    },
    awa: {
      code: 'awa',
      name: 'Awadhi',
      flag: '',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    ay: {
      code: 'ay',
      name: 'Aymara',
      flag: 'https://flagcdn.com/w40/bo.png',
      direction: 'ltr',
      next: 'Nayraqata',
      previous: 'Qhipaqata',
      submit: 'Apayaña',
      errSelect: 'Mayjt’ayaña mayni jach’a',
      errAtMost: 'Janiw juk’amp {**} ajlliñanak ajllikiti',
      errAtleast: 'Janiw juk’ampi {**} ajlliñanak ajllikiti',
      errExactly: '{**} ajlliñanakak ajllima',
      errRequired: 'Aka campo ch’ama',
      alreadySubmitted: 'Janiw aka encuesta apaykiti',
      endMessage: 'Kusikiptwa! Encuesta tukuyta 🎉',
      closedMessage: 'Aka encuesta jist’atawa',
    },
    az: {
      code: 'az',
      name: 'Azerbaijani',
      flag: 'https://flagcdn.com/w40/az.png',
      direction: 'ltr',
      next: 'Növbəti',
      previous: 'Əvvəlki',
      submit: 'Göndər',
      errSelect: 'Zəhmət olmasa, sualı cavablandırın',
      errAtMost: 'Zəhmət olmasa, ən çox {**} seçim edin',
      errAtleast: 'Zəhmət olmasa, ən azı {**} seçim edin',
      errExactly: 'Zəhmət olmasa, dəqiq {**} seçim edin',
      errRequired: 'Bu sahə tələb olunur',
      alreadySubmitted: 'Bu sorğunu artıq göndərmisiniz',
      endMessage: 'Təbrik edirik! Sorğunu tamamladınız  🎉',
      closedMessage: 'Bu sorğu bağlanıb',
    },
    ban: {
      code: 'ban',
      name: 'Balinese',
      flag: 'https://flagcdn.com/w40/id.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    bm: {
      code: 'bm',
      name: 'Bambara',
      flag: 'https://flagcdn.com/w40/ml.png',
      direction: 'ltr',
      next: 'Kɔnɔ',
      previous: 'Kuma',
      submit: 'Tugu',
      errSelect: 'Ala ka fɔlɔ ka fɔ',
      errAtMost: 'Ka tɔgɔ {**} bɔ',
      errAtleast: 'Ka tɔgɔ {**} bɔ',
      errExactly: 'Ka tɔgɔ {**} bɔ',
      errRequired: 'Fɔlɔ ye bɛɛ',
      alreadySubmitted: 'I tugu kɛ',
      endMessage: 'I ni ce! I tugu kɛ 🎉',
      closedMessage: 'Tugu bɛɛ',
    },
    ba: {
      code: 'ba',
      name: 'Bashkir',
      flag: 'https://flagcdn.com/w40/ru.png',
      direction: 'ltr',
      next: 'Киләһе',
      previous: 'Алдағы',
      submit: 'Ебәрергә',
      errSelect: 'Һорауға яуап бирегеҙ',
      errAtMost: 'Күп тигәндә {**} вариант һайлағыҙ',
      errAtleast: 'Кәм тигәндә {**} вариант һайлағыҙ',
      errExactly: 'Тап {**} вариант һайлағыҙ',
      errRequired: 'Был ялан мотлаҡ',
      alreadySubmitted: 'Һеҙ был һораунаманы ебәргәнһегеҙ',
      endMessage: 'Ҡотлайбыҙ! Һеҙ һораунаманы тамамланығыҙ 🎉',
      closedMessage: 'Һораунама ябылған',
    },
    eu: {
      code: 'eu',
      name: 'Basque',
      flag: 'https://flagcdn.com/w40/es.png',
      direction: 'ltr',
      next: 'Hurrengoa',
      previous: 'Aurrekoa',
      submit: 'Bidali',
      errSelect: 'Mesedez, erantzun galderari',
      errAtMost: 'Gehienez {**} aukera hautatu',
      errAtleast: 'Gutxienez {**} aukera hautatu',
      errExactly: 'Zehazki {**} aukera hautatu',
      errRequired: 'Eremu hau beharrezkoa da',
      alreadySubmitted: 'Jada bidali duzu inkesta hau',
      endMessage: 'Zorionak! Inkesta amaitu duzu 🎉',
      closedMessage: 'Inkesta hau itxita dago',
    },
    btx: {
      code: 'btx',
      name: 'Batak Karo',
      flag: 'https://flagcdn.com/w40/id.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    bts: {
      code: 'bts',
      name: 'Batak Simalungun',
      flag: 'https://flagcdn.com/w40/id.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    bbc: {
      code: 'bbc',
      name: 'Batak Toba',
      flag: 'https://flagcdn.com/w40/id.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    be: {
      code: 'be',
      name: 'Belarusian',
      flag: 'https://flagcdn.com/w40/by.png',
      direction: 'ltr',
      next: 'Наступны',
      previous: 'Папярэдні',
      submit: 'Адправіць',
      errSelect: 'Калі ласка, адкажыце на пытанне',
      errAtMost: 'Калі ласка, абярыце не больш за {**} варыянты',
      errAtleast: 'Калі ласка, абярыце не менш за {**} варыянты',
      errExactly: 'Калі ласка, абярыце дакладна {**} варыянты',
      errRequired: 'Гэта поле абавязковае',
      alreadySubmitted: 'Вы ўжо адправілі гэты апытанне',
      endMessage: 'Віншуем! Вы завяршылі апытанне 🎉',
      closedMessage: 'Гэта апытанне закрыта',
    },
    bem: {
      code: 'bem',
      name: 'Bemba',
      flag: 'https://flagcdn.com/w40/zm.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    bn: {
      code: 'bn',
      name: 'Bengali',
      flag: 'https://flagcdn.com/w40/bd.png',
      direction: 'ltr',
      next: 'পরবর্তী',
      previous: 'পূর্ববর্তী',
      submit: 'জমা দিন',
      errSelect: 'অনুগ্রহ করে প্রশ্নের উত্তর দিন',
      errAtMost: 'অনুগ্রহ করে সর্বাধিক {**} বিকল্প নির্বাচন করুন',
      errAtleast: 'অনুগ্রহ করে অন্তত {**} বিকল্প নির্বাচন করুন',
      errExactly: 'অনুগ্রহ করে ঠিক {**} বিকল্প নির্বাচন করুন',
      errRequired: 'এই ক্ষেত্রটি আবশ্যক',
      alreadySubmitted: 'আপনি ইতিমধ্যে এই সমীক্ষাটি জমা দিয়েছেন',
      endMessage: 'অভিনন্দন! আপনি সমীক্ষাটি সম্পন্ন করেছেন 🎉',
      closedMessage: 'এই সমীক্ষাটি বন্ধ',
    },
    bew: {
      code: 'bew',
      name: 'Betawi',
      flag: 'https://flagcdn.com/w40/id.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    bho: {
      code: 'bho',
      name: 'Bhojpuri',
      flag: 'https://flagcdn.com/w40/in.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    bik: {
      code: 'bik',
      name: 'Bikol',
      flag: 'https://flagcdn.com/w40/ph.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    bs: {
      code: 'bs',
      name: 'Bosnian',
      flag: 'https://flagcdn.com/w40/ba.png',
      direction: 'ltr',
      next: 'Sljedeće',
      previous: 'Prethodno',
      submit: 'Pošalji',
      errSelect: 'Molimo odgovorite na pitanje',
      errAtMost: 'Molimo odaberite najviše {**} opcija',
      errAtleast: 'Molimo odaberite najmanje {**} opcija',
      errExactly: 'Molimo odaberite točno {**} opcija',
      errRequired: 'Ovo polje je obavezno',
      alreadySubmitted: 'Već ste poslali ovu anketu',
      endMessage: 'Čestitamo! Završili ste anketu 🎉',
      closedMessage: 'Ova anketa je zatvorena',
    },
    br: {
      code: 'br',
      name: 'Breton',
      flag: 'https://flagcdn.com/w40/fr.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    bg: {
      code: 'bg',
      name: 'Bulgarian',
      flag: 'https://flagcdn.com/w40/bg.png',
      direction: 'ltr',
      next: 'Следващ',
      previous: 'Предишен',
      submit: 'Изпрати',
      errSelect: 'Моля, отговорете на въпроса',
      errAtMost: 'Моля, изберете най-много {**} опции',
      errAtleast: 'Моля, изберете поне {**} опции',
      errExactly: 'Моля, изберете точно {**} опции',
      errRequired: 'Това поле е задължително',
      alreadySubmitted: 'Вече сте изпратили тази анкета',
      endMessage: 'Поздравления! Вие завършихте анкетата 🎉',
      closedMessage: 'Тази анкета е затворена',
    },
    bua: {
      code: 'bua',
      name: 'Buryat',
      flag: 'https://flagcdn.com/w40/ru.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    yue: {
      code: 'yue',
      name: 'Cantonese',
      flag: 'https://flagcdn.com/w40/hk.png',
      direction: 'ltr',
      next: '下一步',
      previous: '上一步',
      submit: '提交',
      errSelect: '請回答問題',
      errAtMost: '請最多選擇 {**} 個選項',
      errAtleast: '請至少選擇 {**} 個選項',
      errExactly: '請恰好選擇 {**} 個選項',
      errRequired: '此欄位為必填',
      alreadySubmitted: '你已經提交了這份問卷',
      endMessage: '恭喜！你已完成問卷 🎉',
      closedMessage: '此問卷已關閉',
    },
    ca: {
      code: 'ca',
      name: 'Catalan',
      flag: 'https://flagcdn.com/w40/es.png',
      direction: 'ltr',
      next: 'Següent',
      previous: 'Anterior',
      submit: 'Enviar',
      errSelect: 'Si us plau, responeu la pregunta',
      errAtMost: 'Si us plau, seleccioneu com a màxim {**} opcions',
      errAtleast: 'Si us plau, seleccioneu com a mínim {**} opcions',
      errExactly: 'Si us plau, seleccioneu exactament {**} opcions',
      errRequired: 'Aquest camp és obligatori',
      alreadySubmitted: 'Ja heu enviat aquesta enquesta',
      endMessage: "Enhorabona! Heu completat l'enquesta 🎉",
      closedMessage: 'Aquesta enquesta està tancada',
    },
    ceb: {
      code: 'ceb',
      name: 'Cebuano',
      flag: 'https://flagcdn.com/w40/ph.png',
      direction: 'ltr',
      next: 'Sunod',
      previous: 'Miagi',
      submit: 'Isumite',
      errSelect: 'Palihug tubaga ang pangutana',
      errAtMost: 'Palihug pagpili sa labing daghan nga {**} mga kapilian',
      errAtleast: 'Palihug pagpili sa labing menos {**} mga kapilian',
      errExactly: 'Palihug pagpili sa eksakto nga {**} mga kapilian',
      errRequired: 'Kinahanglan kini nga field',
      alreadySubmitted: 'Gisumite na nimo kini nga survey',
      endMessage: 'Congratulations! Nahuman na nimo ang survey 🎉',
      closedMessage: 'Ang kini nga survey sirado na',
    },
    ny: {
      code: 'ny',
      name: 'Chichewa',
      flag: 'https://flagcdn.com/w40/mw.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    zh: {
      code: 'zh',
      name: 'Chinese',
      flag: 'https://flagcdn.com/w40/cn.png',
      direction: 'ltr',
      next: '下一步',
      previous: '上一步',
      submit: '提交',
      errSelect: '请回答问题',
      errAtMost: '请最多选择 {**} 个选项',
      errAtleast: '请至少选择 {**} 个选项',
      errExactly: '请恰好选择 {**} 个选项',
      errRequired: '此字段是必需的',
      alreadySubmitted: '您已经提交了此调查',
      endMessage: '恭喜！您已完成调查 🎉',
      closedMessage: '此调查已关闭',
    },
    'zh-TW': {
      code: 'zh-TW',
      name: 'Chinese (Traditional)',
      flag: 'https://flagcdn.com/w40/tw.png',
      direction: 'ltr',
      next: '下一步',
      previous: '上一步',
      submit: '提交',
      errSelect: '請回答問題',
      errAtMost: '請最多選擇 {**} 個選項',
      errAtleast: '請至少選擇 {**} 個選項',
      errExactly: '請恰好選擇 {**} 個選項',
      errRequired: '此欄位為必填',
      alreadySubmitted: '您已經提交了此問卷',
      endMessage: '恭喜！您已完成問卷 🎉',
      closedMessage: '此問卷已關閉',
    },
    cv: {
      code: 'cv',
      name: 'Chuvash',
      flag: 'https://flagcdn.com/w40/ru.png',
      direction: 'ltr',
      next: 'Килесӗ',
      previous: 'Пурӑна',
      submit: 'Ӗҫлӗ',
      errSelect: 'Сурахӑнӗ ҫӗрӗшӗн',
      errAtMost: 'Кӗҫене {**} вариант ҫулӑ',
      errAtleast: 'Кӗҫене {**} вариант ҫулӑ',
      errExactly: '{**} вариант ҫулӑ',
      errRequired: 'Пӗр поле тӗрӗҫ',
      alreadySubmitted: 'Пӗр анкета пурӑн',
      endMessage: 'Кӗрҫӗр! Анкета тӗнчӗҫҫӗн 🎉',
      closedMessage: 'Анкета ятӑн',
    },
    co: {
      code: 'co',
      name: 'Corsican',
      flag: 'https://flagcdn.com/w40/fr.png',
      direction: 'ltr',
      next: 'Seguente',
      previous: 'Precedente',
      submit: 'Invia',
      errSelect: 'Per piacè rispondi à a quistione',
      errAtMost: 'Selezziunate al massimu {**} opzioni',
      errAtleast: 'Selezziunate almenu {**} opzioni',
      errExactly: 'Selezziunate esattamente {**} opzioni',
      errRequired: 'Stu campu hè necessariu',
      alreadySubmitted: 'Avete digià inviatu stu sondaghju',
      endMessage: 'Felicitazioni! Avete compiu u sondaghju 🎉',
      closedMessage: 'Stu sondaghju hè chjosu',
    },
    crh: {
      code: 'crh',
      name: 'Crimean Tatar',
      flag: 'https://flagcdn.com/w40/ua.png',
      direction: 'ltr',
      next: 'Keyingi',
      previous: 'Avvalki',
      submit: 'Yuberiñiz',
      errSelect: 'Lütfen soruvğa cevap beriñiz',
      errAtMost: 'En fazla {**} variant saylañız',
      errAtleast: 'En az {**} variant saylañız',
      errExactly: 'Tam {**} variant saylañız',
      errRequired: 'Bu alan şarttır',
      alreadySubmitted: 'Bu anketa artıq yollandı',
      endMessage: 'Tebrikler! Anketanı tamamladınız 🎉',
      closedMessage: 'Bu anketa qapalıdır',
    },
    hr: {
      code: 'hr',
      name: 'Croatian',
      flag: 'https://flagcdn.com/w40/hr.png',
      direction: 'ltr',
      next: 'Sljedeće',
      previous: 'Prethodno',
      submit: 'Pošalji',
      errSelect: 'Molimo odgovorite na pitanje',
      errAtMost: 'Odaberite najviše {**} opcija',
      errAtleast: 'Odaberite najmanje {**} opcija',
      errExactly: 'Odaberite točno {**} opcija',
      errRequired: 'Ovo polje je obavezno',
      alreadySubmitted: 'Već ste poslali ovu anketu',
      endMessage: 'Čestitamo! Završili ste anketu 🎉',
      closedMessage: 'Ova anketa je zatvorena',
    },
    cs: {
      code: 'cs',
      name: 'Czech',
      flag: 'https://flagcdn.com/w40/cz.png',
      direction: 'ltr',
      next: 'Další',
      previous: 'Předchozí',
      submit: 'Odeslat',
      errSelect: 'Prosím, odpovězte na otázku',
      errAtMost: 'Vyberte nejvýše {**} možností',
      errAtleast: 'Vyberte alespoň {**} možností',
      errExactly: 'Vyberte přesně {**} možností',
      errRequired: 'Toto pole je povinné',
      alreadySubmitted: 'Tento průzkum jste již odeslali',
      endMessage: 'Gratulujeme! Dokončili jste průzkum 🎉',
      closedMessage: 'Tento průzkum je uzavřen',
    },
    da: {
      code: 'da',
      name: 'Danish',
      flag: 'https://flagcdn.com/w40/dk.png',
      direction: 'ltr',
      next: 'Næste',
      previous: 'Forrige',
      submit: 'Indsend',
      errSelect: 'Besvar venligst spørgsmålet',
      errAtMost: 'Vælg højst {**} muligheder',
      errAtleast: 'Vælg mindst {**} muligheder',
      errExactly: 'Vælg præcis {**} muligheder',
      errRequired: 'Dette felt er påkrævet',
      alreadySubmitted: 'Du har allerede indsendt denne undersøgelse',
      endMessage: 'Tillykke! Du har gennemført undersøgelsen 🎉',
      closedMessage: 'Denne undersøgelse er lukket',
    },
    din: {
      code: 'din',
      name: 'Dinka',
      flag: '',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    dv: {
      code: 'dv',
      name: 'Divehi',
      flag: 'https://flagcdn.com/w40/mv.png',
      direction: 'rtl',
      next: 'ކުރިންވަރީ',
      previous: 'ކުރިންދެން',
      submit: 'ހުށަހައްޓައި',
      errSelect: 'މަޢުލޫމާތް ޖަވާބުކުރޭ',
      errAtMost: 'އަދިއަށް {**} އޮޕްޝަންތައް ނުވަތަ ނަމަވެސް ނަމަވެސް ނަމަވެސް',
      errAtleast: 'އަދިއަށް {**} އޮޕްޝަންތައް ނަމަވެސް',
      errExactly: '{**} އޮޕްޝަންތައް މަޢުލޫމާތް',
      errRequired: 'މަޢުލޫމާތް ބައްދަލުކުރޭ',
      alreadySubmitted: 'މަޢުލޫމާތް ކުރިއަށް ހުށަހައްޓައި',
      endMessage: 'މަޢުލޫމާތް ކުރިއަށް ހުށަހައްޓައި 🎉',
      closedMessage: 'މަޢުލޫމާތް ބައްދަލުކުރޭ',
    },
    doi: {
      code: 'doi',
      name: 'Dogri',
      flag: 'https://flagcdn.com/w40/in.png',
      direction: 'ltr',
      next: 'अगला',
      previous: 'पिछला',
      submit: 'जमा करें',
      errSelect: 'कृपया प्रश्न का उत्तर दें',
      errAtMost: 'कृपया अधिकतम {**} विकल्प चुनें',
      errAtleast: 'कृपया कम से कम {**} विकल्प चुनें',
      errExactly: 'कृपया ठीक {**} विकल्प चुनें',
      errRequired: 'यह फ़ील्ड आवश्यक है',
      alreadySubmitted: 'आप पहले ही यह सर्वेक्षण जमा कर चुके हैं',
      endMessage: 'बधाई हो! आपने सर्वेक्षण पूरा कर लिया है 🎉',
      closedMessage: 'यह सर्वेक्षण बंद है',
    },
    dov: {
      code: 'dov',
      name: 'Dombe',
      flag: '',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    nl: {
      code: 'nl',
      name: 'Dutch',
      flag: 'https://flagcdn.com/w40/nl.png',
      direction: 'ltr',
      next: 'Volgende',
      previous: 'Vorige',
      submit: 'Indienen',
      errSelect: 'Beantwoord de vraag alstublieft',
      errAtMost: 'Selecteer maximaal {**} opties',
      errAtleast: 'Selecteer minimaal {**} opties',
      errExactly: 'Selecteer precies {**} opties',
      errRequired: 'Dit veld is verplicht',
      alreadySubmitted: 'U heeft deze enquête al ingediend',
      endMessage: 'Gefeliciteerd! U heeft de enquête voltooid 🎉',
      closedMessage: 'Deze enquête is gesloten',
    },
    dz: {
      code: 'dz',
      name: 'Dzongkha',
      flag: 'https://flagcdn.com/w40/bt.png',
      direction: 'ltr',
      next: 'ཤུལ་མར།',
      previous: 'ཧེ་མར།',
      submit: 'བཏུབ།',
      errSelect: 'དགོས་མཁོ་ཡོད་པའི་དྲི་བ་ལན་འདེབས།',
      errAtMost: 'མང་མཐའ་རུ་འདེམས་ཆོག་{**} གདམ་ཁ།',
      errAtleast: 'ཉུང་མཐའ་རུ་འདེམས་ཆོག་{**} གདམ་ཁ།',
      errExactly: '{**} གདམ་ཁ་ཡིན་དགོས།',
      errRequired: 'འདི་ནང་བསྡུས་དགོས།',
      alreadySubmitted: 'ཁྱེད་ཀྱིས་འདི་ཧེ་མ་སྤེལ་ཡོད།',
      endMessage: 'བཀྲ་ཤིས་བདེ་ལེགས། ཁྱེད་ཀྱིས་དཔྱད་ཞིབ་མཇུག་བསྡུས་ཡོད། 🎉',
      closedMessage: 'དཔྱད་ཞིབ་འདི་ཁ་བསྡམས་ཡོད།',
    },
    en: {
      code: 'en',
      name: 'English',
      flag: 'https://flagcdn.com/w40/gb.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    eo: {
      code: 'eo',
      name: 'Esperanto',
      flag: 'https://flagcdn.com/w40/001.png',
      direction: 'ltr',
      next: 'Sekva',
      previous: 'Antaŭa',
      submit: 'Sendu',
      errSelect: 'Bonvolu respondi la demandon',
      errAtMost: 'Bonvolu elekti maksimume {**} opciojn',
      errAtleast: 'Bonvolu elekti almenaŭ {**} opciojn',
      errExactly: 'Bonvolu elekti ĝuste {**} opciojn',
      errRequired: 'Ĉi tiu kampo estas deviga',
      alreadySubmitted: 'Vi jam sendis ĉi tiun enketon',
      endMessage: 'Gratulojn! Vi finis la enketon 🎉',
      closedMessage: 'Ĉi tiu enketo estas fermita',
    },
    et: {
      code: 'et',
      name: 'Estonian',
      flag: 'https://flagcdn.com/w40/ee.png',
      direction: 'ltr',
      next: 'Järgmine',
      previous: 'Eelmine',
      submit: 'Esita',
      errSelect: 'Palun vastake küsimusele',
      errAtMost: 'Valige maksimaalselt {**} valikut',
      errAtleast: 'Valige vähemalt {**} valikut',
      errExactly: 'Valige täpselt {**} valikut',
      errRequired: 'See väli on kohustuslik',
      alreadySubmitted: 'Olete selle küsitluse juba esitanud',
      endMessage: 'Õnnitleme! Olete küsitluse lõpetanud 🎉',
      closedMessage: 'See küsitlus on suletud',
    },
    ee: {
      code: 'ee',
      name: 'Ewe',
      flag: 'https://flagcdn.com/w40/tg.png',
      direction: 'ltr',
      next: 'Tɔgbɔ',
      previous: 'Tɔxɛ',
      submit: 'Dɔ',
      errSelect: 'Mɛkpɔe be nàɖu nu',
      errAtMost: 'Nàɖu {**} nu max',
      errAtleast: 'Nàɖu {**} nu min',
      errExactly: 'Nàɖu {**} nu exact',
      errRequired: 'Nu sia le agbe',
      alreadySubmitted: 'Wòtsɔ survey sia ɖe',
      endMessage: 'Woezɔ! Wòtsɔ survey sia ɖe 🎉',
      closedMessage: 'Survey sia le xɔ',
    },
    fj: {
      code: 'fj',
      name: 'Fijian',
      flag: 'https://flagcdn.com/w40/fj.png',
      direction: 'ltr',
      next: 'Tarava',
      previous: 'Muri',
      submit: 'Tukuna',
      errSelect: 'Yalovinaka, saumi na taro',
      errAtMost: 'Digitaka e sega ni sivia {**} na digidigi',
      errAtleast: 'Digitaka e sega ni lailai mai na {**} na digidigi',
      errExactly: 'Digitaka ga na {**} na digidigi',
      errRequired: 'E dodonu me vakayacori na vanua oqo',
      alreadySubmitted: 'O sa vakauta oti tu na vakadidike oqo',
      endMessage: 'Vina du riki! O sa vakacavara na vakadidike 🎉',
      closedMessage: 'Sa sogo na vakadidike oqo',
    },
    fil: {
      code: 'fil',
      name: 'Filipino',
      flag: 'https://flagcdn.com/w40/ph.png',
      direction: 'ltr',
      next: 'Susunod',
      previous: 'Nakaraan',
      submit: 'Isumite',
      errSelect: 'Pakisagot ang tanong',
      errAtMost: 'Pumili ng hanggang {**} opsyon',
      errAtleast: 'Pumili ng hindi bababa sa {**} opsyon',
      errExactly: 'Pumili ng eksaktong {**} opsyon',
      errRequired: 'Kinakailangan ang field na ito',
      alreadySubmitted: 'Naipasa mo na ang survey na ito',
      endMessage: 'Binabati kita! Natapos mo na ang survey 🎉',
      closedMessage: 'Sarado na ang survey na ito',
    },
    fi: {
      code: 'fi',
      name: 'Finnish',
      flag: 'https://flagcdn.com/w40/fi.png',
      direction: 'ltr',
      next: 'Seuraava',
      previous: 'Edellinen',
      submit: 'Lähetä',
      errSelect: 'Vastaa kysymykseen',
      errAtMost: 'Valitse enintään {**} vaihtoehtoa',
      errAtleast: 'Valitse vähintään {**} vaihtoehtoa',
      errExactly: 'Valitse tarkalleen {**} vaihtoehtoa',
      errRequired: 'Tämä kenttä on pakollinen',
      alreadySubmitted: 'Olet jo lähettänyt tämän kyselyn',
      endMessage: 'Onnittelut! Olet suorittanut kyselyn 🎉',
      closedMessage: 'Tämä kysely on suljettu',
    },
    fr: {
      code: 'fr',
      name: 'French',
      flag: 'https://flagcdn.com/w40/fr.png',
      direction: 'ltr',
      next: 'Suivant',
      previous: 'Précédent',
      submit: 'Soumettre',
      errSelect: 'Veuillez répondre à la question',
      errAtMost: 'Veuillez sélectionner au maximum {**} options',
      errAtleast: 'Veuillez sélectionner au moins {**} options',
      errExactly: 'Veuillez sélectionner exactement {**} options',
      errRequired: 'Ce champ est obligatoire',
      alreadySubmitted: 'Vous avez déjà soumis ce sondage',
      endMessage: 'Félicitations ! Vous avez terminé le sondage 🎉',
      closedMessage: 'Ce sondage est fermé',
    },
    'fr-FR': {
      code: 'fr-FR',
      name: 'French (France)',
      flag: 'https://flagcdn.com/w40/fr.png',
      direction: 'ltr',
      next: 'Suivant',
      previous: 'Précédent',
      submit: 'Soumettre',
      errSelect: 'Veuillez répondre à la question',
      errAtMost: 'Veuillez sélectionner au maximum {**} options',
      errAtleast: 'Veuillez sélectionner au moins {**} options',
      errExactly: 'Veuillez sélectionner exactement {**} options',
      errRequired: 'Ce champ est obligatoire',
      alreadySubmitted: 'Vous avez déjà soumis ce sondage',
      endMessage: 'Félicitations ! Vous avez terminé le sondage 🎉',
      closedMessage: 'Ce sondage est fermé',
    },
    'fr-CA': {
      code: 'fr-CA',
      name: 'French (Canada)',
      flag: 'https://flagcdn.com/w40/ca.png',
      direction: 'ltr',
      next: 'Suivant',
      previous: 'Précédent',
      submit: 'Soumettre',
      errSelect: 'Veuillez répondre à la question',
      errAtMost: 'Veuillez sélectionner au maximum {**} options',
      errAtleast: 'Veuillez sélectionner au moins {**} options',
      errExactly: 'Veuillez sélectionner exactement {**} options',
      errRequired: 'Ce champ est obligatoire',
      alreadySubmitted: 'Vous avez déjà soumis ce sondage',
      endMessage: 'Félicitations ! Vous avez terminé le sondage 🎉',
      closedMessage: 'Ce sondage est fermé',
    },
    fy: {
      code: 'fy',
      name: 'Frisian',
      flag: 'https://flagcdn.com/w40/nl.png',
      direction: 'ltr',
      next: 'Folgjende',
      previous: 'Foarige',
      submit: 'Yntsjinje',
      errSelect: 'Beäntwurdzje de fraach asjebleaft',
      errAtMost: 'Selektearje op syn heechst {**} opsjes',
      errAtleast: 'Selektearje op syn minst {**} opsjes',
      errExactly: 'Selektearje krekt {**} opsjes',
      errRequired: 'Dit fjild is ferplicht',
      alreadySubmitted: 'Jo hawwe dizze enkête al yntsjinne',
      endMessage: 'Lokwinske! Jo hawwe de enkête foltôge 🎉',
      closedMessage: 'Dizze enkête is sluten',
    },
    ff: {
      code: 'ff',
      name: 'Fulfulde',
      flag: 'https://flagcdn.com/w40/sn.png',
      direction: 'ltr',
      next: 'Jokkondir',
      previous: 'Jokkondir',
      submit: 'Naat',
      errSelect: 'A jooɗiima jooɗi',
      errAtMost: 'A suɓo {**} suɓo',
      errAtleast: 'A suɓo {**} suɓo',
      errExactly: '{**} suɓo suɓo',
      errRequired: 'Ndaari ndiyam',
      alreadySubmitted: 'A naatani ndiyam',
      endMessage: 'A jaaraama! A naatani ndiyam 🎉',
      closedMessage: 'Ndiyam ndiyam',
    },
    gaa: {
      code: 'gaa',
      name: 'Ga',
      flag: 'https://flagcdn.com/w40/gh.png',
      direction: 'ltr',
      next: 'Nii',
      previous: 'Nii',
      submit: 'Tee',
      errSelect: 'Mɛkpɔe be nàɖu nu',
      errAtMost: 'Nàɖu {**} nu max',
      errAtleast: 'Nàɖu {**} nu min',
      errExactly: 'Nàɖu {**} nu exact',
      errRequired: 'Nu sia le agbe',
      alreadySubmitted: 'Wòtsɔ survey sia ɖe',
      endMessage: 'Woezɔ! Wòtsɔ survey sia ɖe 🎉',
      closedMessage: 'Survey sia le xɔ',
    },
    gl: {
      code: 'gl',
      name: 'Galician',
      flag: 'https://flagcdn.com/w40/es.png',
      direction: 'ltr',
      next: 'Seguinte',
      previous: 'Anterior',
      submit: 'Enviar',
      errSelect: 'Responda á pregunta por favor',
      errAtMost: 'Seleccione como máximo {**} opcións',
      errAtleast: 'Seleccione polo menos {**} opcións',
      errExactly: 'Seleccione exactamente {**} opcións',
      errRequired: 'Este campo é obrigatorio',
      alreadySubmitted: 'Xa enviou esta enquisa',
      endMessage: 'Parabéns! Completou a enquisa 🎉',
      closedMessage: 'Esta enquisa está pechada',
    },
    lg: {
      code: 'lg',
      name: 'Ganda',
      flag: 'https://flagcdn.com/w40/ug.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    ka: {
      code: 'ka',
      name: 'Georgian',
      flag: 'https://flagcdn.com/w40/ge.png',
      direction: 'ltr',
      next: 'შემდეგი',
      previous: 'წინა',
      submit: 'გაგზავნა',
      errSelect: 'გთხოვთ, უპასუხოთ კითხვას',
      errAtMost: 'აირჩიეთ მაქსიმუმ {**} ვარიანტი',
      errAtleast: 'აირჩიეთ მინიმუმ {**} ვარიანტი',
      errExactly: 'აირჩიეთ ზუსტად {**} ვარიანტი',
      errRequired: 'ეს ველი სავალდებულოა',
      alreadySubmitted: 'თქვენ უკვე გაგზავნეთ ეს გამოკითხვა',
      endMessage: 'გილოცავთ! თქვენ დაასრულეთ გამოკითხვა 🎉',
      closedMessage: 'ეს გამოკითხვა დახურულია',
    },
    de: {
      code: 'de',
      name: 'German',
      flag: 'https://flagcdn.com/w40/de.png',
      direction: 'ltr',
      next: 'Weiter',
      previous: 'Zurück',
      submit: 'Absenden',
      errSelect: 'Bitte beantworten Sie die Frage',
      errAtMost: 'Bitte wählen Sie höchstens {**} Optionen',
      errAtleast: 'Bitte wählen Sie mindestens {**} Optionen',
      errExactly: 'Bitte wählen Sie genau {**} Optionen',
      errRequired: 'Dieses Feld ist erforderlich',
      alreadySubmitted: 'Sie haben diese Umfrage bereits eingereicht',
      endMessage:
        'Herzlichen Glückwunsch! Sie haben die Umfrage abgeschlossen 🎉',
      closedMessage: 'Diese Umfrage ist geschlossen',
    },
    el: {
      code: 'el',
      name: 'Greek',
      flag: 'https://flagcdn.com/w40/gr.png',
      direction: 'ltr',
      next: 'Επόμενο',
      previous: 'Προηγούμενο',
      submit: 'Υποβολή',
      errSelect: 'Παρακαλώ απαντήστε στην ερώτηση',
      errAtMost: 'Επιλέξτε το πολύ {**} επιλογές',
      errAtleast: 'Επιλέξτε τουλάχιστον {**} επιλογές',
      errExactly: 'Επιλέξτε ακριβώς {**} επιλογές',
      errRequired: 'Αυτό το πεδίο είναι υποχρεωτικό',
      alreadySubmitted: 'Έχετε ήδη υποβάλει αυτήν την έρευνα',
      endMessage: 'Συγχαρητήρια! Ολοκληρώσατε την έρευνα 🎉',
      closedMessage: 'Αυτή η έρευνα έχει κλείσει',
    },
    gn: {
      code: 'gn',
      name: 'Guarani',
      flag: 'https://flagcdn.com/w40/py.png',
      direction: 'ltr',
      next: 'Upeigua',
      previous: 'Tenondegua',
      submit: 'Mondo',
      errSelect: 'Embohovái pe porandú',
      errAtMost: 'Eiporavo hetave {**} opción',
      errAtleast: 'Eiporavo michĩvéva {**} opción',
      errExactly: 'Eiporavo haĝua {**} opción',
      errRequired: 'Ko campo oñemohendáva',
      alreadySubmitted: 'Reñemohendáma ko encuesta',
      endMessage: 'Aguyje! Reikuaáma encuesta 🎉',
      closedMessage: 'Ko encuesta oñemboty',
    },
    gu: {
      code: 'gu',
      name: 'Gujarati',
      flag: 'https://flagcdn.com/w40/in.png',
      direction: 'ltr',
      next: 'આગળ',
      previous: 'પાછળ',
      submit: 'મોકલો',
      errSelect: 'કૃપા કરીને પ્રશ્નનો જવાબ આપો',
      errAtMost: 'મહત્તમ {**} વિકલ્પો પસંદ કરો',
      errAtleast: 'ઓછામાં ઓછા {**} વિકલ્પો પસંદ કરો',
      errExactly: 'ખાસ {**} વિકલ્પો પસંદ કરો',
      errRequired: 'આ ફીલ્ડ જરૂરી છે',
      alreadySubmitted: 'તમે આ સર્વે પહેલેથી જ મોકલી દીધો છે',
      endMessage: 'અભિનંદન! તમે સર્વે પૂર્ણ કર્યો છે 🎉',
      closedMessage: 'આ સર્વે બંધ છે',
    },
    ht: {
      code: 'ht',
      name: 'Haitian Creole',
      flag: 'https://flagcdn.com/w40/ht.png',
      direction: 'ltr',
      next: 'Pwochen',
      previous: 'Anvan',
      submit: 'Voye',
      errSelect: 'Tanpri reponn kesyon an',
      errAtMost: 'Tanpri chwazi omwen {**} opsyon',
      errAtleast: 'Tanpri chwazi omwen {**} opsyon',
      errExactly: 'Tanpri chwazi egzakteman {**} opsyon',
      errRequired: 'Champs sa a obligatwa',
      alreadySubmitted: 'Ou deja soumèt sondaj sa a',
      endMessage: 'Felisitasyon! Ou fini sondaj la 🎉',
      closedMessage: 'Sondaj sa a fèmen',
    },
    cnh: {
      code: 'cnh',
      name: 'Hakha Chin',
      flag: 'https://flagcdn.com/w40/mm.png',
      direction: 'ltr',
      next: 'Mah dih',
      previous: 'a hlaan',
      submit: 'Submit tuah',
      errSelect: 'Zaangfahnak tein biahalnak kha rak ka leh',
      errAtMost: 'Zaangfahnak tein a tam bik {**} thimnak kha thim',
      errAtleast: 'A tlawmbik {**} thimnak kha thim',
      errExactly: 'Zaangfahnak tein {**} thimnak kha thim',
      errRequired: 'Hi hmun hi a herh',
      alreadySubmitted: 'Hi hlathlainak hi na pek cang',
      endMessage: 'Lunglawmhnak! Hlathlainak na tuah dih cang 🎉',
      closedMessage: 'Hi hlathlainak cu khar a si cang',
    },
    es: {
      code: 'es',
      name: 'Spanish',
      flag: 'https://flagcdn.com/w40/es.png',
      direction: 'ltr',
      next: 'Siguiente',
      previous: 'Anterior',
      submit: 'Enviar',
      errSelect: 'Por favor, responda a la pregunta',
      errAtMost: 'Por favor, seleccione como máximo {**} opciones',
      errAtleast: 'Por favor, seleccione al menos {**} opciones',
      errExactly: 'Por favor, seleccione exactamente {**} opciones',
      errRequired: 'Este campo es obligatorio',
      alreadySubmitted: 'Ya has enviado esta encuesta',
      endMessage: '¡Felicidades! Has completado la encuesta 🎉',
      closedMessage: 'Esta encuesta está cerrada',
    },
    fa: {
      code: 'fa',
      name: 'Persian',
      flag: 'https://flagcdn.com/w40/ir.png',
      direction: 'rtl',
      next: 'بعدی',
      previous: 'قبلی',
      submit: 'ارسال',
      errSelect: 'لطفاً به سؤال پاسخ دهید',
      errAtMost: 'حداکثر {**} گزینه را انتخاب کنید',
      errAtleast: 'حداقل {**} گزینه را انتخاب کنید',
      errExactly: 'دقیقاً {**} گزینه را انتخاب کنید',
      errRequired: 'این فیلد الزامی است',
      alreadySubmitted: 'شما قبلاً این نظرسنجی را ارسال کرده‌اید',
      endMessage: 'تبریک! شما نظرسنجی را کامل کردید 🎉',
      closedMessage: 'این نظرسنجی بسته شده است',
    },
    it: {
      code: 'it',
      name: 'Italian',
      flag: 'https://flagcdn.com/w40/it.png',
      direction: 'ltr',
      next: 'Avanti',
      previous: 'Precedente',
      submit: 'Invia',
      errSelect: 'Per favore rispondi alla domanda',
      errAtMost: 'Seleziona al massimo {**} opzioni',
      errAtleast: 'Seleziona almeno {**} opzioni',
      errExactly: 'Seleziona esattamente {**} opzioni',
      errRequired: 'Questo campo è obbligatorio',
      alreadySubmitted: 'Hai già inviato questo sondaggio',
      endMessage: 'Congratulazioni! Hai completato il sondaggio 🎉',
      closedMessage: 'Questo sondaggio è chiuso',
    },
    pt: {
      code: 'pt',
      name: 'Portuguese',
      flag: 'https://flagcdn.com/w40/pt.png',
      direction: 'ltr',
      next: 'Próximo',
      previous: 'Anterior',
      submit: 'Enviar',
      errSelect: 'Por favor, responda à pergunta',
      errAtMost: 'Selecione no máximo {**} opções',
      errAtleast: 'Selecione pelo menos {**} opções',
      errExactly: 'Selecione exatamente {**} opções',
      errRequired: 'Este campo é obrigatório',
      alreadySubmitted: 'Você já enviou esta pesquisa',
      endMessage: 'Parabéns! Você completou a pesquisa 🎉',
      closedMessage: 'Esta pesquisa está fechada',
    },
    pa: {
      code: 'pa',
      name: 'Punjabi',
      flag: 'https://flagcdn.com/w40/in.png',
      direction: 'ltr',
      next: 'ਅਗਲਾ',
      previous: 'ਪਿਛਲਾ',
      submit: 'ਜਮ੍ਹਾਂ ਕਰੋ',
      errSelect: 'ਕਿਰਪਾ ਕਰਕੇ ਸਵਾਲ ਦਾ ਜਵਾਬ ਦਿਓ',
      errAtMost: 'ਵੱਧ ਤੋਂ ਵੱਧ {**} ਵਿਕਲਪ ਚੁਣੋ',
      errAtleast: 'ਘੱਟੋ-ਘੱਟ {**} ਵਿਕਲਪ ਚੁਣੋ',
      errExactly: 'ਠੀਕ {**} ਵਿਕਲਪ ਚੁਣੋ',
      errRequired: 'ਇਹ ਫੀਲਡ ਲਾਜ਼ਮੀ ਹੈ',
      alreadySubmitted: 'ਤੁਸੀਂ ਪਹਿਲਾਂ ਹੀ ਇਹ ਸਰਵੇਖਣ ਜਮ੍ਹਾਂ ਕਰ ਚੁੱਕੇ ਹੋ',
      endMessage: 'ਵਧਾਈਆਂ! ਤੁਸੀਂ ਸਰਵੇਖਣ ਪੂਰਾ ਕਰ ਲਿਆ ਹੈ 🎉',
      closedMessage: 'ਇਹ ਸਰਵੇਖਣ ਬੰਦ ਹੈ',
    },
    ur: {
      code: 'ur',
      name: 'Urdu',
      flag: 'https://flagcdn.com/w40/pk.png',
      direction: 'rtl',
      next: 'اگلا',
      previous: 'پچھلا',
      submit: 'جمع کرائیں',
      errSelect: 'براہ کرم سوال کا جواب دیں',
      errAtMost: 'براہ کرم زیادہ سے زیادہ {**} اختیارات منتخب کریں',
      errAtleast: 'براہ کرم کم از کم {**} اختیارات منتخب کریں',
      errExactly: 'براہ کرم بالکل {**} اختیارات منتخب کریں',
      errRequired: 'یہ فیلڈ ضروری ہے',
      alreadySubmitted: 'آپ نے پہلے ہی اس سروے کو جمع کرایا ہے',
      endMessage: ' 🎉مبارک ہو! آپ نے سروے مکمل کر لیا ہے',
      closedMessage: 'یہ سروے بند ہے',
    },
    tr: {
      code: 'tr',
      name: 'Turkish',
      flag: 'https://flagcdn.com/w40/tr.png',
      direction: 'ltr',
      next: 'Sonraki',
      previous: 'Önceki',
      submit: 'Gönder',
      errSelect: 'Lütfen soruyu cevaplayın',
      errAtMost: 'En fazla {**} seçenek seçin',
      errAtleast: 'En az {**} seçenek seçin',
      errExactly: '{**} seçenek tam olarak seçin',
      errRequired: 'Bu alan gereklidir',
      alreadySubmitted: 'Bu anketi zaten gönderdiniz',
      endMessage: 'Tebrikler! Anketi tamamladınız 🎉',
      closedMessage: 'Bu anket kapalıdır',
    },
    uk: {
      code: 'uk',
      name: 'Ukrainian',
      flag: 'https://flagcdn.com/w40/ua.png',
      direction: 'ltr',
      next: 'Далі',
      previous: 'Назад',
      submit: 'Відправити',
      errSelect: 'Будь ласка, дайте відповідь на питання',
      errAtMost: 'Виберіть не більше {**} варіантів',
      errAtleast: 'Виберіть щонайменше {**} варіантів',
      errExactly: 'Виберіть рівно {**} варіантів',
      errRequired: "Це поле обов'язкове",
      alreadySubmitted: 'Ви вже відправили це опитування',
      endMessage: 'Вітаємо! Ви завершили опитування 🎉',
      closedMessage: 'Це опитування закрито',
    },
    vi: {
      code: 'vi',
      name: 'Vietnamese',
      flag: 'https://flagcdn.com/w40/vn.png',
      direction: 'ltr',
      next: 'Tiếp theo',
      previous: 'Trước',
      submit: 'Gửi',
      errSelect: 'Vui lòng trả lời câu hỏi',
      errAtMost: 'Chọn tối đa {**} lựa chọn',
      errAtleast: 'Chọn ít nhất {**} lựa chọn',
      errExactly: 'Chọn chính xác {**} lựa chọn',
      errRequired: 'Trường này là bắt buộc',
      alreadySubmitted: 'Bạn đã gửi khảo sát này',
      endMessage: 'Chúc mừng! Bạn đã hoàn thành khảo sát 🎉',
      closedMessage: 'Khảo sát này đã đóng',
    },
    cy: {
      code: 'cy',
      name: 'Welsh',
      flag: 'https://flagcdn.com/w40/gb-wls.png',
      direction: 'ltr',
      next: 'Nesaf',
      previous: 'Blaenorol',
      submit: 'Cyflwyno',
      errSelect: 'Atebwch y cwestiwn os gwelwch yn dda',
      errAtMost: 'Dewiswch uchafswm o {**} opsiwn',
      errAtleast: 'Dewiswch o leiaf {**} opsiwn',
      errExactly: 'Dewiswch union {**} opsiwn',
      errRequired: "Mae angen llenwi'r maes hwn",
      alreadySubmitted: "Rydych eisoes wedi cyflwyno'r arolwg hwn",
      endMessage: "Llongyfarchiadau! Rydych wedi cwblhau'r arolwg 🎉",
      closedMessage: "Mae'r arolwg hwn wedi cau",
    },
    id: {
      code: 'id',
      name: 'Indonesian',
      flag: 'https://flagcdn.com/w40/id.png',
      direction: 'ltr',
      next: 'Berikutnya',
      previous: 'Sebelumnya',
      submit: 'Kirim',
      errSelect: 'Silakan jawab pertanyaannya',
      errAtMost: 'Pilih paling banyak {**} opsi',
      errAtleast: 'Pilih setidaknya {**} opsi',
      errExactly: 'Pilih tepat {**} opsi',
      errRequired: 'Bidang ini wajib diisi',
      alreadySubmitted: 'Anda sudah mengirim survei ini',
      endMessage: 'Selamat! Anda telah menyelesaikan survei 🎉',
      closedMessage: 'Survei ini ditutup',
    },
    ja: {
      code: 'ja',
      name: 'Japanese',
      flag: 'https://flagcdn.com/w40/jp.png',
      direction: 'ltr',
      next: '次へ',
      previous: '前へ',
      submit: '送信',
      errSelect: '質問に答えてください',
      errAtMost: '最大で{**}個のオプションを選択してください',
      errAtleast: '少なくとも{**}個のオプションを選択してください',
      errExactly: '{**}個のオプションを正確に選択してください',
      errRequired: 'このフィールドは必須です',
      alreadySubmitted: 'このアンケートはすでに送信されています',
      endMessage: 'おめでとうございます！アンケートが完了しました 🎉',
      closedMessage: 'このアンケートは終了しました',
    },
    ko: {
      code: 'ko',
      name: 'Korean',
      flag: 'https://flagcdn.com/w40/kr.png',
      direction: 'ltr',
      next: '다음',
      previous: '이전',
      submit: '제출',
      errSelect: '질문에 답해주세요',
      errAtMost: '최대 {**} 옵션을 선택하세요',
      errAtleast: '최소 {**} 옵션을 선택하세요',
      errExactly: '{**} 옵션을 정확히 선택하세요',
      errRequired: '이 필드는 필수입니다',
      alreadySubmitted: '이미 이 설문조사를 제출했습니다',
      endMessage: '축하합니다! 설문조사를 완료했습니다 🎉',
      closedMessage: '이 설문조사는 종료되었습니다',
    },
    pl: {
      code: 'pl',
      name: 'Polish',
      flag: 'https://flagcdn.com/w40/pl.png',
      direction: 'ltr',
      next: 'Dalej',
      previous: 'Wstecz',
      submit: 'Wyślij',
      errSelect: 'Proszę odpowiedzieć na pytanie',
      errAtMost: 'Wybierz maksymalnie {**} opcji',
      errAtleast: 'Wybierz co najmniej {**} opcji',
      errExactly: 'Wybierz dokładnie {**} opcji',
      errRequired: 'To pole jest wymagane',
      alreadySubmitted: 'Już wysłałeś tę ankietę',
      endMessage: 'Gratulacje! Ukończyłeś ankietę 🎉',
      closedMessage: 'Ta ankieta jest zamknięta',
    },
    sv: {
      code: 'sv',
      name: 'Swedish',
      flag: 'https://flagcdn.com/w40/se.png',
      direction: 'ltr',
      next: 'Nästa',
      previous: 'Föregående',
      submit: 'Skicka in',
      errSelect: 'Vänligen svara på frågan',
      errAtMost: 'Välj högst {**} alternativ',
      errAtleast: 'Välj minst {**} alternativ',
      errExactly: 'Välj exakt {**} alternativ',
      errRequired: 'Detta fält är obligatoriskt',
      alreadySubmitted: 'Du har redan skickat in denna undersökning',
      endMessage: 'Grattis! Du har slutfört undersökningen 🎉',
      closedMessage: 'Denna undersökning är stängd',
    },
    zh: {
      code: 'zh',
      name: 'Chinese',
      flag: 'https://flagcdn.com/w40/cn.png',
      direction: 'ltr',
      next: '下一步',
      previous: '上一步',
      submit: '提交',
      errSelect: '请回答问题',
      errAtMost: '请最多选择 {**} 个选项',
      errAtleast: '请至少选择 {**} 个选项',
      errExactly: '请恰好选择 {**} 个选项',
      errRequired: '此字段是必需的',
      alreadySubmitted: '您已经提交了此调查',
      endMessage: '恭喜！您已完成调查 🎉',
      closedMessage: '此调查已关闭',
    },
    ro: {
      code: 'ro',
      name: 'Romanian',
      flag: 'https://flagcdn.com/w40/ro.png',
      direction: 'ltr',
      next: 'Următorul',
      previous: 'Anterior',
      submit: 'Trimite',
      errSelect: 'Vă rugăm să răspundeți la întrebare',
      errAtMost: 'Vă rugăm să selectați cel mult {**} opțiuni',
      errAtleast: 'Vă rugăm să selectați cel puțin {**} opțiuni',
      errExactly: 'Vă rugăm să selectați exact {**} opțiuni',
      errRequired: 'Acest câmp este obligatoriu',
      alreadySubmitted: 'Ați trimis deja acest sondaj',
      endMessage: 'Felicitări! Ați completat sondajul 🎉',
      closedMessage: 'Acest sondaj este închis',
    },
    ru: {
      code: 'ru',
      name: 'Russian',
      flag: 'https://flagcdn.com/w40/ru.png',
      direction: 'ltr',
      next: 'Далее',
      previous: 'Назад',
      submit: 'Отправить',
      errSelect: 'Пожалуйста, ответьте на вопрос',
      errAtMost: 'Выберите не более {**} вариантов',
      errAtleast: 'Выберите как минимум {**} вариантов',
      errExactly: 'Выберите ровно {**} вариантов',
      errRequired: 'Это поле обязательно для заполнения',
      alreadySubmitted: 'Вы уже отправили этот опрос',
      endMessage: 'Поздравляем! Вы завершили опрос 🎉',
      closedMessage: 'Этот опрос закрыт',
    },

    /////////////////
    ////////////////////
    ////////////////////
    /////////////////////////////

    ha: {
      code: 'ha',
      name: 'Hausa',
      flag: 'https://flagcdn.com/w40/ng.png',
      direction: 'ltr',
      next: 'Gaba',
      previous: 'Baya',
      submit: 'Aika',
      errSelect: 'Da fatan za a amsa tambayar',
      errAtMost: 'Da fatan za a zaɓi mafi yawa {**} zaɓuɓɓuka',
      errAtleast: 'Da fatan za a zaɓi aƙalla {**} zaɓuɓɓuka',
      errExactly: 'Da fatan za a zaɓi daidai zaɓin {**}',
      errRequired: 'Wannan filin ana bukatansa',
      alreadySubmitted: 'Kun riga kun ƙaddamar da wannan binciken',
      endMessage: 'Taya murna! Kun kammala binciken 🎉',
      closedMessage: 'An rufe wannan binciken',
    },
    haw: {
      code: 'haw',
      name: 'Hawaiian',
      flag: 'https://flagcdn.com/w40/us.png',
      direction: 'ltr',
      next: 'I Mua',
      previous: 'I Hope',
      submit: 'E hoʻouna',
      errSelect: 'E ʻoluʻolu e pane i ka nīnau',
      errAtMost: 'E koho i ka nui loa o {**} koho',
      errAtleast: 'E koho i ka liʻiliʻi o {**} koho',
      errExactly: 'E koho pololei i {**} koho',
      errRequired: 'Pākuʻi i kēia kahua',
      alreadySubmitted: 'Ua hoʻouna mua ʻoe i kēia nīnau',
      endMessage: 'Hoʻomaikaʻi! Ua hoʻopau ʻoe i ka nīnau 🎉',
      closedMessage: 'Ua pani ʻia kēia nīnau',
    },
    he: {
      code: 'he',
      name: 'Hebrew',
      flag: 'https://flagcdn.com/w40/il.png',
      direction: 'rtl',
      next: 'הבא',
      previous: 'הקודם',
      submit: 'שלח',
      errSelect: 'אנא ענה על השאלה',
      errAtMost: 'אנא בחר עד {**} אפשרויות',
      errAtleast: 'אנא בחר לפחות {**} אפשרויות',
      errExactly: 'אנא בחר בדיוק {**} אפשרויות',
      errRequired: 'שדה זה נדרש',
      alreadySubmitted: 'כבר שלחת את הסקר הזה',
      endMessage: 'ברכות! השלמת את הסקר 🎉',
      closedMessage: 'הסקר הזה סגור',
    },
    hil: {
      code: 'hil',
      name: 'Hiligaynon',
      flag: 'https://flagcdn.com/w40/ph.png',
      direction: 'ltr',
      next: 'Sunod',
      previous: 'Naligad',
      submit: 'Isumite',
      errSelect: 'Palihog sabta ang pamangkot',
      errAtMost: 'Palihog pili sang labing madamo {**} kapilian',
      errAtleast: 'Palihog pili sang labing manubo {**} kapilian',
      errExactly: 'Palihog pili sang eksakto nga {**} kapilian',
      errRequired: 'Kinahanglan ini nga field',
      alreadySubmitted: 'Nakasumite ka na sini nga survey',
      endMessage: 'Congratulations! Natapos mo na ang survey 🎉',
      closedMessage: 'Sirado na ini nga survey',
    },
    hmn: {
      code: 'hmn',
      name: 'Hmong',
      flag: '',
      direction: 'ltr',
      next: 'Tom ntej',
      previous: 'Tom qab',
      submit: 'Xa',
      errSelect: 'Thov teb lo lus nug',
      errAtMost: 'Thov xaiv ntau tshaj plaws {**} xaiv',
      errAtleast: 'Thov xaiv tsawg kawg {**} xaiv',
      errExactly: 'Thov xaiv raws nraim {**} xaiv',
      errRequired: 'Thov sau daim teb no',
      alreadySubmitted: 'Koj twb xa daim ntawv no lawm',
      endMessage: 'Zoo siab! Koj ua tiav daim ntawv nug lawm 🎉',
      closedMessage: 'Daim ntawv nug no raug kaw lawm',
    },
    hu: {
      code: 'hu',
      name: 'Hungarian',
      flag: 'https://flagcdn.com/w40/hu.png',
      direction: 'ltr',
      next: 'Következő',
      previous: 'Előző',
      submit: 'Beküldés',
      errSelect: 'Kérjük, válaszoljon a kérdésre',
      errAtMost: 'Legfeljebb {**} lehetőséget válasszon ki',
      errAtleast: 'Legalább {**} lehetőséget válasszon ki',
      errExactly: 'Pontosan {**} lehetőséget válasszon ki',
      errRequired: 'Ez a mező kötelező',
      alreadySubmitted: 'Már beküldte ezt a felmérést',
      endMessage: 'Gratulálunk! Befejezte a felmérést 🎉',
      closedMessage: 'Ez a felmérés lezárult',
    },
    hrx: {
      code: 'hrx',
      name: 'Hunsrik',
      flag: 'https://flagcdn.com/w40/br.png',
      direction: 'ltr',
      next: 'Próximo',
      previous: 'Anterior',
      submit: 'Enviar',
      errSelect: 'Por favor, responda à pergunta',
      errAtMost: 'Selecione no máximo {**} opções',
      errAtleast: 'Selecione pelo menos {**} opções',
      errExactly: 'Selecione exatamente {**} opções',
      errRequired: 'Este campo é obrigatório',
      alreadySubmitted: 'Você já enviou esta pesquisa',
      endMessage: 'Parabéns! Você completou a pesquisa 🎉',
      closedMessage: 'Esta pesquisa está fechada',
    },
    is: {
      code: 'is',
      name: 'Icelandic',
      flag: 'https://flagcdn.com/w40/is.png',
      direction: 'ltr',
      next: 'Næsta',
      previous: 'Fyrri',
      submit: 'Senda',
      errSelect: 'Vinsamlegast svaraðu spurningunni',
      errAtMost: 'Veldu að hámarki {**} valkosti',
      errAtleast: 'Veldu að minnsta kosti {**} valkosti',
      errExactly: 'Veldu nákvæmlega {**} valkosti',
      errRequired: 'Þessi reitur er nauðsynlegur',
      alreadySubmitted: 'Þú hefur þegar sent inn þessa könnun',
      endMessage: 'Til hamingju! Þú hefur lokið könnuninni 🎉',
      closedMessage: 'Þessi könnun er lokuð',
    },
    ig: {
      code: 'ig',
      name: 'Igbo',
      flag: 'https://flagcdn.com/w40/ng.png',
      direction: 'ltr',
      next: 'Na-esote',
      previous: 'Gara aga',
      submit: 'Nyefee',
      errSelect: 'Biko zaa ajụjụ a',
      errAtMost: 'Biko họrọ ihe kachasị {**} nhọrọ',
      errAtleast: 'Biko họrọ ihe dịkarịa ala {**} nhọrọ',
      errExactly: 'Biko họrọ kpọmkwem {**} nhọrọ',
      errRequired: 'A chọrọ ubi a',
      alreadySubmitted: 'I tinyela azịza a na nyocha a',
      endMessage: 'Ekele! I mechara nyocha a 🎉',
      closedMessage: 'Nnyocha a mechiri emechi',
    },
    ilo: {
      code: 'ilo',
      name: 'Iloko',
      flag: 'https://flagcdn.com/w40/ph.png',
      direction: 'ltr',
      next: 'Sumaruno',
      previous: 'Naglabas',
      submit: 'Isumite',
      errSelect: 'Pakisagot ti saludsod',
      errAtMost: 'Agpili kadagiti ad-adu a {**} pagpilian',
      errAtleast: 'Agpili kadagiti bassit a {**} pagpilian',
      errExactly: 'Agpili kadagiti eksakto nga {**} pagpilian',
      errRequired: 'Masapul daytoy a field',
      alreadySubmitted: 'Naipasa mon daytoy a surbey',
      endMessage: 'Congratulations! Naitungpal mo ti surbey 🎉',
      closedMessage: 'Nasarado daytoy a surbey',
    },
    ga: {
      code: 'ga',
      name: 'Irish',
      flag: 'https://flagcdn.com/w40/ie.png',
      direction: 'ltr',
      next: 'Ar Aghaidh',
      previous: 'Roimhe Seo',
      submit: 'Cuir isteach',
      errSelect: 'Freagair an cheist le do thoil',
      errAtMost: 'Roghnaigh suas le {**} rogha',
      errAtleast: 'Roghnaigh ar a laghad {**} rogha',
      errExactly: 'Roghnaigh go díreach {**} rogha',
      errRequired: 'Tá an réimse seo riachtanach',
      alreadySubmitted: 'Tá an suirbhé seo curtha isteach agat cheana féin',
      endMessage: 'Comhghairdeas! Tá an suirbhé críochnaithe agat 🎉',
      closedMessage: 'Tá an suirbhé seo dúnta',
    },
    jv: {
      code: 'jv',
      name: 'Javanese',
      flag: 'https://flagcdn.com/w40/id.png',
      direction: 'ltr',
      next: 'Sabanjure',
      previous: 'Sadurunge',
      submit: 'Kirim',
      errSelect: 'Mangga wangsulana pitakonan',
      errAtMost: 'Pilih paling akeh {**} pilihan',
      errAtleast: 'Pilih paling ora {**} pilihan',
      errExactly: 'Pilih pas {**} pilihan',
      errRequired: 'Kolom iki kudu diisi',
      alreadySubmitted: 'Sampeyan wis ngirim survey iki',
      endMessage: 'Sugeng! Sampeyan wis ngrampungake survey 🎉',
      closedMessage: 'Survey iki wis ditutup',
    },
    kn: {
      code: 'kn',
      name: 'Kannada',
      flag: 'https://flagcdn.com/w40/in.png',
      direction: 'ltr',
      next: 'ಮುಂದೆ',
      previous: 'ಹಿಂದೆ',
      submit: 'ಸಲ್ಲಿಸು',
      errSelect: 'ದಯವಿಟ್ಟು ಪ್ರಶ್ನೆಗೆ ಉತ್ತರಿಸಿ',
      errAtMost: 'ಗರಿಷ್ಠ {**} ಆಯ್ಕೆಗಳನ್ನು ಆಯ್ಕೆಮಾಡಿ',
      errAtleast: 'ಕನಿಷ್ಠ {**} ಆಯ್ಕೆಗಳನ್ನು ಆಯ್ಕೆಮಾಡಿ',
      errExactly: '{**} ಆಯ್ಕೆಗಳನ್ನು ಆಯ್ಕೆಮಾಡಿ',
      errRequired: 'ಈ ಕ್ಷೇತ್ರ ಅಗತ್ಯವಿದೆ',
      alreadySubmitted: 'ನೀವು ಈ ಸಮೀಕ್ಷೆಯನ್ನು ಈಗಾಗಲೇ ಸಲ್ಲಿಸಿದ್ದೀರಿ',
      endMessage: 'ಅಭಿನಂದನೆಗಳು! ನೀವು ಸಮೀಕ್ಷೆಯನ್ನು ಪೂರ್ಣಗೊಳಿಸಿದ್ದೀರಿ 🎉',
      closedMessage: 'ಈ ಸಮೀಕ್ಷೆ ಮುಚ್ಚಲಾಗಿದೆ',
    },
    pam: {
      code: 'pam',
      name: 'Kapampangan',
      flag: 'https://flagcdn.com/w40/ph.png',
      direction: 'ltr',
      next: 'Sunud',
      previous: 'Mibalik',
      submit: 'Isumite',
      errSelect: 'Pakisagut ing pamag-utana',
      errAtMost: 'Pili yang dakal {**} opsyun',
      errAtleast: 'Pili yang alilan {**} opsyun',
      errExactly: 'Pili yang eksakto {**} opsyun',
      errRequired: 'Alang kapamilatan ing field a iti',
      alreadySubmitted: 'Mekasumite naka king survey a iti',
      endMessage: 'Congratulations! Mekatapos naka king survey 🎉',
      closedMessage: 'Mekasara ne ing survey a iti',
    },
    kk: {
      code: 'kk',
      name: 'Kazakh',
      flag: 'https://flagcdn.com/w40/kz.png',
      direction: 'ltr',
      next: 'Келесі',
      previous: 'Алдыңғы',
      submit: 'Жіберу',
      errSelect: 'Сұраққа жауап беріңіз',
      errAtMost: 'Ең көбі {**} нұсқаны таңдаңыз',
      errAtleast: 'Кемінде {**} нұсқаны таңдаңыз',
      errExactly: 'Дәл {**} нұсқаны таңдаңыз',
      errRequired: 'Бұл өріс міндетті',
      alreadySubmitted: 'Сіз бұл сауалнаманы жібердіңіз',
      endMessage: 'Құттықтаймыз! Сауалнаманы аяқтадыңыз 🎉',
      closedMessage: 'Бұл сауалнама жабық',
    },
    km: {
      code: 'km',
      name: 'Khmer',
      flag: 'https://flagcdn.com/w40/kh.png',
      direction: 'ltr',
      next: 'បន្ទាប់',
      previous: 'មុន',
      submit: 'ដាក់ស្នើ',
      errSelect: 'សូមឆ្លើយសំណួរ',
      errAtMost: 'សូមជ្រើសរើសច្រើនបំផុត {**} ជម្រើស',
      errAtleast: 'សូមជ្រើសរើសយ៉ាងហោចណាស់ {**} ជម្រើស',
      errExactly: 'សូមជ្រើសរើសជាក់លាក់ {**} ជម្រើស',
      errRequired: 'វាលនេះត្រូវការជាចាំបាច់',
      alreadySubmitted: 'អ្នកបានដាក់ស្នើសំណួរនេះរួចហើយ',
      endMessage: 'អបអរសាទរ! អ្នកបានបញ្ចប់ការស្ទង់មតិ 🎉',
      closedMessage: 'ការស្ទង់មតិនេះបានបិទ',
    },
    cgg: {
      code: 'cgg',
      name: 'Kiga',
      flag: 'https://flagcdn.com/w40/ug.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    rw: {
      code: 'rw',
      name: 'Kinyarwanda',
      flag: 'https://flagcdn.com/w40/rw.png',
      direction: 'ltr',
      next: 'Ibikurikira',
      previous: 'Ibyabanje',
      submit: 'Ohereza',
      errSelect: 'Nyamuneka subiza ikibazo',
      errAtMost: 'Hitamo nibura {**} amahitamo',
      errAtleast: 'Hitamo nibura {**} amahitamo',
      errExactly: 'Hitamo neza {**} amahitamo',
      errRequired: 'Iri saha rirakenewe',
      alreadySubmitted: 'Wamaze kohereza iyi surivayi',
      endMessage: 'Ibyiza! Warangije surivayi 🎉',
      closedMessage: 'Iyi surivayi yarafunzwe',
    },
    ktu: {
      code: 'ktu',
      name: 'Kituba',
      flag: 'https://flagcdn.com/w40/cg.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    gom: {
      code: 'gom',
      name: 'Konkani',
      flag: 'https://flagcdn.com/w40/in.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    kri: {
      code: 'kri',
      name: 'Krio',
      flag: 'https://flagcdn.com/w40/sl.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    ku: {
      code: 'ku',
      name: 'Kurdish',
      flag: 'https://flagcdn.com/w40/iq.png',
      direction: 'ltr',
      next: 'Pêş',
      previous: 'Paş',
      submit: 'Nerdin',
      errSelect: 'Ji kerema xwe bersivê bidin pirsê',
      errAtMost: 'Ji kerema xwe zêdetirîn {**} vebijêrk hilbijêrin',
      errAtleast: 'Ji kerema xwe kêmî {**} vebijêrk hilbijêrin',
      errExactly: 'Ji kerema xwe rastî {**} vebijêrk hilbijêrin',
      errRequired: 'Ev qada pêwîste',
      alreadySubmitted: 'Hûn vê lêkolînê jixwe şandine',
      endMessage: 'Pîrozbahî! Hûn lêkolînê qedandine 🎉',
      closedMessage: 'Ev lêkolîn girtî ye',
    },
    ky: {
      code: 'ky',
      name: 'Kyrgyz',
      flag: 'https://flagcdn.com/w40/kg.png',
      direction: 'ltr',
      next: 'Кийинки',
      previous: 'Мурунку',
      submit: 'Жөнөтүү',
      errSelect: 'Сураныч, суроого жооп бериңиз',
      errAtMost: 'Көп дегенде {**} вариант тандаңыз',
      errAtleast: 'Аз дегенде {**} вариант тандаңыз',
      errExactly: 'Так {**} вариант тандаңыз',
      errRequired: 'Бул талаа талап кылынат',
      alreadySubmitted: 'Бул сурамжылоону жөнөттүңүз',
      endMessage: 'Куттуктайбыз! Сурамжылоону аяктадыңыз 🎉',
      closedMessage: 'Бул сурамжылоо жабык',
    },
    lo: {
      code: 'lo',
      name: 'Lao',
      flag: 'https://flagcdn.com/w40/la.png',
      direction: 'ltr',
      next: 'ຖັດໄປ',
      previous: 'ກ່ອນໜ້າ',
      submit: 'ສົ່ງ',
      errSelect: 'ກະລຸນາຕອບຄຳຖາມ',
      errAtMost: 'ເລືອກສູງສຸດ {**} ຕົວເລືອກ',
      errAtleast: 'ເລືອກຢ່າງນ້ອຍ {**} ຕົວເລືອກ',
      errExactly: 'ເລືອກແນ່ນອນ {**} ຕົວເລືອກ',
      errRequired: 'ຕ້ອງການຟິວນີ້',
      alreadySubmitted: 'ທ່ານໄດ້ສົ່ງແບບສຳຫຼວດນີ້ແລ້ວ',
      endMessage: 'ຍິນດີ! ທ່ານໄດ້ສຳເລັດແບບສຳຫຼວດ 🎉',
      closedMessage: 'ແບບສຳຫຼວດນີ້ຖືກປິດແລ້ວ',
    },
    ltg: {
      code: 'ltg',
      name: 'Latgalian',
      flag: 'https://flagcdn.com/w40/lv.png',
      direction: 'ltr',
      next: 'Nākošais',
      previous: 'Iepriekšējais',
      submit: 'Iesniegt',
      errSelect: 'Lūdzu, atbildiet uz jautājumu',
      errAtMost: 'Izvēlieties ne vairāk kā {**} opcijas',
      errAtleast: 'Izvēlieties vismaz {**} opcijas',
      errExactly: 'Izvēlieties tieši {**} opcijas',
      errRequired: 'Šis lauks ir obligāts',
      alreadySubmitted: 'Jūs jau esat iesniedzis šo aptauju',
      endMessage: 'Apsveicam! Jūs esat pabeidzis aptauju 🎉',
      closedMessage: 'Šī aptauja ir slēgta',
    },
    la: {
      code: 'la',
      name: 'Latin',
      flag: 'https://flagcdn.com/w40/va.png',
      direction: 'ltr',
      next: 'Proximum',
      previous: 'Praecedens',
      submit: 'Submittere',
      errSelect: 'Quaeso responde quaestioni',
      errAtMost: 'Quaeso selige ad summum {**} optiones',
      errAtleast: 'Quaeso selige saltem {**} optiones',
      errExactly: 'Quaeso selige exacte {**} optiones',
      errRequired: 'Hoc campus requiritur',
      alreadySubmitted: 'Iam hanc quaestionem misisti',
      endMessage: 'Gratulamur! Quaestionem perfecisti 🎉',
      closedMessage: 'Haec quaestio clausa est',
    },
    lv: {
      code: 'lv',
      name: 'Latvian',
      flag: 'https://flagcdn.com/w40/lv.png',
      direction: 'ltr',
      next: 'Nākamais',
      previous: 'Iepriekšējais',
      submit: 'Iesniegt',
      errSelect: 'Lūdzu, atbildiet uz jautājumu',
      errAtMost: 'Izvēlieties ne vairāk kā {**} opcijas',
      errAtleast: 'Izvēlieties vismaz {**} opcijas',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    lij: {
      code: 'lij',
      name: 'Ligurian',
      flag: 'https://flagcdn.com/w40/it.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    li: {
      code: 'li',
      name: 'Limburgan',
      flag: 'https://flagcdn.com/w40/nl.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    ln: {
      code: 'ln',
      name: 'Lingala',
      flag: 'https://flagcdn.com/w40/cd.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    lt: {
      code: 'lt',
      name: 'Lithuanian',
      flag: 'https://flagcdn.com/w40/lt.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    lmo: {
      code: 'lmo',
      name: 'Lombard',
      flag: 'https://flagcdn.com/w40/it.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    luo: {
      code: 'luo',
      name: 'Luo',
      flag: 'https://flagcdn.com/w40/ke.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    lb: {
      code: 'lb',
      name: 'Luxembourgish',
      flag: 'https://flagcdn.com/w40/lu.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    mk: {
      code: 'mk',
      name: 'Macedonian',
      flag: 'https://flagcdn.com/w40/mk.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    mai: {
      code: 'mai',
      name: 'Maithili',
      flag: 'https://flagcdn.com/w40/in.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    mak: {
      code: 'mak',
      name: 'Makassar',
      flag: 'https://flagcdn.com/w40/id.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    mg: {
      code: 'mg',
      name: 'Malagasy',
      flag: 'https://flagcdn.com/w40/mg.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      submit: 'Submit',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    ms: {
      code: 'ms',
      name: 'Malay',
      flag: 'https://flagcdn.com/w40/my.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    ml: {
      code: 'ml',
      name: 'Malayalam',
      flag: 'https://flagcdn.com/w40/in.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    mt: {
      code: 'mt',
      name: 'Maltese',
      flag: 'https://flagcdn.com/w40/mt.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    mr: {
      code: 'mr',
      name: 'Marathi',
      flag: 'https://flagcdn.com/w40/in.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    mhr: {
      code: 'mhr',
      name: 'Meadow Mari',
      flag: 'https://flagcdn.com/w40/ru.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    mni: {
      code: 'mni',
      name: 'Meiteilon (Manipuri)',
      flag: 'https://flagcdn.com/w40/in.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    min: {
      code: 'min',
      name: 'Minang',
      flag: 'https://flagcdn.com/w40/id.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    lus: {
      code: 'lus',
      name: 'Mizo',
      flag: 'https://flagcdn.com/w40/in.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    mn: {
      code: 'mn',
      name: 'Mongolian',
      flag: 'https://flagcdn.com/w40/mn.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    my: {
      code: 'my',
      name: 'Myanmar (Burmese)',
      flag: 'https://flagcdn.com/w40/mm.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    nbl: {
      code: 'nbl',
      name: 'Ndebele (South)',
      flag: 'https://flagcdn.com/w40/za.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    new: {
      code: 'new',
      name: 'Nepalbhasa (Newari)',
      flag: 'https://flagcdn.com/w40/np.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    ne: {
      code: 'ne',
      name: 'Nepali',
      flag: 'https://flagcdn.com/w40/np.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    nso: {
      code: 'nso',
      name: 'Northern Sotho (Sepedi)',
      flag: 'https://flagcdn.com/w40/za.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    no: {
      code: 'no',
      name: 'Norwegian',
      flag: 'https://flagcdn.com/w40/no.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    nus: {
      code: 'nus',
      name: 'Nuer',
      flag: 'https://flagcdn.com/w40/ss.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    oc: {
      code: 'oc',
      name: 'Occitan',
      flag: 'https://flagcdn.com/w40/fr.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    or: {
      code: 'or',
      name: 'Odia (Oriya)',
      flag: 'https://flagcdn.com/w40/in.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    om: {
      code: 'om',
      name: 'Oromo',
      flag: 'https://flagcdn.com/w40/et.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    pag: {
      code: 'pag',
      name: 'Pangasinan',
      flag: 'https://flagcdn.com/w40/ph.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    pap: {
      code: 'pap',
      name: 'Papiamento',
      flag: 'https://flagcdn.com/w40/cw.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    ps: {
      code: 'ps',
      name: 'Pashto',
      flag: 'https://flagcdn.com/w40/af.png',
      direction: 'rtl',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    pt_PT: {
      code: 'pt-PT',
      name: 'Portuguese (Portugal)',
      flag: 'https://flagcdn.com/w40/pt.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    qu: {
      code: 'qu',
      name: 'Quechua',
      flag: 'https://flagcdn.com/w40/pe.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    rom: {
      code: 'rom',
      name: 'Romani',
      flag: '',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    rn: {
      code: 'rn',
      name: 'Rundi',
      flag: 'https://flagcdn.com/w40/bi.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    sm: {
      code: 'sm',
      name: 'Samoan',
      flag: 'https://flagcdn.com/w40/ws.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    sg: {
      code: 'sg',
      name: 'Sango',
      flag: 'https://flagcdn.com/w40/cf.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    pt_BR: {
      code: 'pt-BR',
      name: 'Portuguese (Brazil)',
      flag: 'https://flagcdn.com/w40/br.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    sa: {
      code: 'sa',
      name: 'Sanskrit',
      flag: 'https://flagcdn.com/w40/in.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    gd: {
      code: 'gd',
      name: 'Scots Gaelic',
      flag: 'https://flagcdn.com/w40/gb.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    sr: {
      code: 'sr',
      name: 'Serbian',
      flag: 'https://flagcdn.com/w40/rs.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    st: {
      code: 'st',
      name: 'Sesotho',
      flag: 'https://flagcdn.com/w40/ls.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    crs: {
      code: 'crs',
      name: 'Seychellois Creole',
      flag: 'https://flagcdn.com/w40/sc.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    shn: {
      code: 'shn',
      name: 'Shan',
      flag: 'https://flagcdn.com/w40/mm.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    sn: {
      code: 'sn',
      name: 'Shona',
      flag: 'https://flagcdn.com/w40/zw.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    scn: {
      code: 'scn',
      name: 'Sicilian',
      flag: 'https://flagcdn.com/w40/it.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    szl: {
      code: 'szl',
      name: 'Silesian',
      flag: 'https://flagcdn.com/w40/pl.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    sd: {
      code: 'sd',
      name: 'Sindhi',
      flag: 'https://flagcdn.com/w40/pk.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    si: {
      code: 'si',
      name: 'Sinhala (Sinhalese)',
      flag: 'https://flagcdn.com/w40/lk.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    sk: {
      code: 'sk',
      name: 'Slovak',
      flag: 'https://flagcdn.com/w40/sk.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    sl: {
      code: 'sl',
      name: 'Slovenian',
      flag: 'https://flagcdn.com/w40/si.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    so: {
      code: 'so',
      name: 'Somali',
      flag: 'https://flagcdn.com/w40/so.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    su: {
      code: 'su',
      name: 'Sundanese',
      flag: 'https://flagcdn.com/w40/id.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    sw: {
      code: 'sw',
      name: 'Swahili',
      flag: 'https://flagcdn.com/w40/tz.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    ss: {
      code: 'ss',
      name: 'Swati',
      flag: 'https://flagcdn.com/w40/sz.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    tg: {
      code: 'tg',
      name: 'Tajik',
      flag: 'https://flagcdn.com/w40/tj.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    ta: {
      code: 'ta',
      name: 'Tamil',
      flag: 'https://flagcdn.com/w40/in.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    tt: {
      code: 'tt',
      name: 'Tatar',
      flag: 'https://flagcdn.com/w40/ru.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    te: {
      code: 'te',
      name: 'Telugu',
      flag: 'https://flagcdn.com/w40/in.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    tet: {
      code: 'tet',
      name: 'Tetum',
      flag: 'https://flagcdn.com/w40/tl.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    th: {
      code: 'th',
      name: 'Thai',
      flag: 'https://flagcdn.com/w40/th.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    ti: {
      code: 'ti',
      name: 'Tigrinya',
      flag: 'https://flagcdn.com/w40/er.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    ts: {
      code: 'ts',
      name: 'Tsonga',
      flag: 'https://flagcdn.com/w40/za.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    tn: {
      code: 'tn',
      name: 'Tswana',
      flag: 'https://flagcdn.com/w40/bw.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    tk: {
      code: 'tk',
      name: 'Turkmen',
      flag: 'https://flagcdn.com/w40/tm.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    tw: {
      code: 'tw',
      name: 'Twi (Akan)',
      flag: 'https://flagcdn.com/w40/gh.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    ug: {
      code: 'ug',
      name: 'Uyghur',
      flag: 'https://flagcdn.com/w40/cn.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    uz: {
      code: 'uz',
      name: 'Uzbek',
      flag: 'https://flagcdn.com/w40/uz.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    xh: {
      code: 'xh',
      name: 'Xhosa',
      flag: 'https://flagcdn.com/w40/za.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    yi: {
      code: 'yi',
      name: 'Yiddish',
      flag: 'https://flagcdn.com/w40/001.png',
      direction: 'rtl',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    yo: {
      code: 'yo',
      name: 'Yoruba',
      flag: 'https://flagcdn.com/w40/ng.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    yua: {
      code: 'yua',
      name: 'Yucatec Maya',
      flag: 'https://flagcdn.com/w40/mx.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
    zu: {
      code: 'zu',
      name: 'Zulu',
      flag: 'https://flagcdn.com/w40/za.png',
      direction: 'ltr',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      errSelect: 'Please answer the question',
      errAtMost: 'Please select at most {**} options',
      errAtleast: 'Please select at least {**} options',
      errExactly: 'Please select exactly {**} options',
      errRequired: 'This field is required',
      alreadySubmitted: 'You have already submitted this survey',
      endMessage: 'Congratulations! You have completed the survey 🎉',
      closedMessage: 'This survey is closed',
    },
  }
  static getLanguage(langCode) {
    return this.translations[langCode]
  }
}

export default LanguageTranslations
